<!--
 * @Author: tjessie
 * @Date: 2025-05-13 16:19:29
 * @LastEditors: tjessie
 * @LastEditTime: 2025-06-10 13:52:21
 * @Description: file content
 * @FilePath: \juqu-pandakt\src\components\pc\pcFooter.vue
-->
<template>
  <div class="footer">
    <div class="code">
      <div>
        <img class="code_img" src="@/assets/code.png" alt="" />
        <div class="mg10">商务合作</div>
        <div class="mg10">请扫码联系我们</div>
      </div>
      <div>
        <img class="code_img" src="@/assets/tencent_isux.png" alt="" />
        <div class="mg10">公众号</div>
        <div class="mg10">扫码关注最新资讯</div>
      </div>
    </div>
    <div class="txt">
      Copyright ©
      {{
        new Date().getFullYear() == "2025" ? "2025" : `2025-${new Date().getFullYear()}`
      }}
      | 湖南米啦科技有限公司版权所有 |
      <a href="http://beian.miit.gov.cn">备案号：湘ICP备2025115029号-2</a>
    </div>
    <div class="mg10">
      公司地址:湖南省长沙市岳麓区天顶街道环湖路 1177号方茂苑（二期）12、13、15栋1916室 |
      联系方式：guohao@hskgoo.com
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  height: 341px;
  background-color: #3a3636;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #afa6a6;
  font-size: 14px;
  min-width: 1200px;
  .mg10 {
    margin-top: 10px;
  }
  .code {
    display: flex;
    width: 400px;
    justify-content: space-between;
    text-align: center;
    .code_img {
      width: 133px;
      height: 133px;
    }
  }
  .txt {
    margin-top: 30px;
    a {
      color: #afa6a6;
    }
  }
}
</style>
